import { Route, Routes, useNavigate } from 'react-router-dom';
import AuthLayout from '../layouts/AuthLayout';
import { useEffect } from 'react';
import LoginPage from '../pages/Login.page';

export default function PublicRoutes() {
  const navigate = useNavigate();
  const currentRoute = window.location.pathname;

  useEffect(() => {
    if (currentRoute != 'login') {
      navigate('/login');
    }
  }, [currentRoute, navigate]);

  return (
    <AuthLayout>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* <Route path="/404" element={<>Helloooooo loggedOut 404</>} />
        <Route path="/*" element={<>Helloooooo Logged out</>} /> */}
      </Routes>
    </AuthLayout>
  );
}
